<template>

  <v-dialog
    v-model="show"
    max-width="400px"
    persistent
  >
    <m-pay-generic-editor
      :title="title"
      :bean="model"
      :beanProperties="beanProperties"
      :beanPropertyValues="beanPropertyValues"
      :validationRules="validationRules"
      submitButtonColor="error"
      @submit="submit($event)"
      @cancel="cancel"
    >
      <template slot="submitButton">
        Refund
        <v-icon right dark>restore</v-icon>
      </template>
    </m-pay-generic-editor>
  </v-dialog>

</template>

<script>
import MPayGenericEditor from './MPayGenericEditor';
import formatters from '../utils/formatters';

export default {
  name: 'MPayTransactionRefund',

  props: {
    show: Boolean,
    transaction: Object,
    manualRefund: Boolean,
  },

  components: {
    MPayGenericEditor,
  },

  data: () => ({
    model: {
      transactionId: '',
      amount: 0,
      currency: '',
      refundReason: this.manualRefund ? 'REFUNDED_MANUALLY' : '',
      refundNote: '',
    },
    beanProperties: [
      'amount',
      'currency',
      'refundReason',
      'refundNote',
    ],
    formatters,
  }),

  computed: {
    validationRules() {
      return [
        `required|between:0.01,${this.transaction.amount}`,
        `required|is:${this.transaction.currency}`,
        'required',
        '',
      ];
    },
    beanPropertyValues() {
      // TODO: fetch reference data from server
      return {
        refundReason: this.manualRefund
          ? ['REFUNDED_MANUALLY']
          : ['PRODUCT_OUT_OF_STOCK', 'RETURNED_PRODUCT', 'CANCELLED_SERVICE', 'PRICE_ADJUSTMENT', 'OTHER_REFUND'],
      };
    },
    title() {
      return this.manualRefund
        ? `Mark as refunded transaction for ${formatters.amount(this.transaction.amount)} ${this.transaction.currency}`
        : `Refund transaction for ${formatters.amount(this.transaction.amount)} ${this.transaction.currency}`;
    },
  },

  methods: {
    submit(model) {
      this.$emit('update:show', false);
      this.$emit('refund', model);
    },
    cancel() {
      this.$emit('update:show', false);
    },
    resetModel() {
      this.model = {
        transactionId: this.transaction.id,
        amount: this.transaction.amount,
        currency: this.transaction.currency,
        refundReason: this.manualRefund ? 'REFUNDED_MANUALLY' : '',
        refundNote: '',
      };
    },
  },

  watch: {
    transaction() {
      this.resetModel();
    },
    show() {
      this.resetModel();
    },
  },

};
</script>



// WEBPACK FOOTER //
// src/components/MPayTransactionRefund.vue